import { useState, useMemo } from 'react';
import { Tabs, Tab, Box, Typography, CircularProgress } from '@mui/material';

import TabPanel from 'Components/TabPanel';
import { RenderChart } from 'Chart/Chart';
import { useFetchingStore } from 'Store';
import { Totals } from 'Chart/Totals';

const Charts = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const responses = useFetchingStore(state => state.resp.filter(x => Object.keys(x.human_readable).length > 0));
  const fetching = useFetchingStore(state => state.fetching);

  // take the human readable keys & the units for each from the first response
  const humanReadableKeys = responses[0]?.human_readable || {};
  const units = responses[0]?.units || {};
  // filter out date from the available y axis keys shown in the dropdown
  const keys = Object.keys(humanReadableKeys)?.filter(key => key !== 'date');

  const responsesWithId = useMemo(() => 
    responses
    .filter(entry => entry.data?.length > 0)
    .map((entry, index) => ({
      ...entry,
      run_id: index + 1
  })), [responses]);

  const handleChange = (event, newIndex) => setTabIndex(newIndex);

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant='h6' textAlign='center' sx={{ my: 2 }}>
        Your Emissions Forecast
      </Typography>
      <Typography variant='body2' textAlign='center' sx={{ mb: 2 }}>
        These results show predicted methane emissions for your chosen slurry emptying date.
        Emissions drop on this date since no slurry is stored. <br />
        Use the button at the bottom of the page to try and find a date that lowers TOTAL emissions.
      </Typography>

      <Tabs
        value={tabIndex}
        onChange={handleChange}
        centered
        indicatorColor='primary'
        textColor='primary'
      >
        <Tab label='Time Trends' />
        <Tab label='Totals' />
      </Tabs>

      <TabPanel selectedTabIndex={tabIndex} index={0}>
        {fetching ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : (
          <RenderChart data={responsesWithId} keys={keys} humanReadableKeys={humanReadableKeys} units={units} />
        )}
      </TabPanel>

      <TabPanel selectedTabIndex={tabIndex} index={1}>
        <Totals data={responsesWithId} />
      </TabPanel>
    </Box>
  );
};

export default Charts;
